import { render } from "./Impress.vue?vue&type=template&id=0f505cad&scoped=true"
import script from "./Impress.vue?vue&type=script&lang=js"
export * from "./Impress.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f505cad"]])

export default __exports__